import { render } from "./GetInputs.vue?vue&type=template&id=45b1eef1&scoped=true"
import script from "./GetInputs.vue?vue&type=script&lang=js"
export * from "./GetInputs.vue?vue&type=script&lang=js"

import "./GetInputs.vue?vue&type=style&index=0&id=45b1eef1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b1eef1"]])

export default __exports__